import { render } from "./SecurityOptions.vue?vue&type=template&id=c6841fc6&scoped=true"
import script from "./SecurityOptions.vue?vue&type=script&lang=js"
export * from "./SecurityOptions.vue?vue&type=script&lang=js"

import "./SecurityOptions.vue?vue&type=style&index=0&id=c6841fc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6841fc6"]])

export default __exports__